// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".variant." + {"2897":"6c5f33952065fb071920","3490":"b28103499d7277a89d57"}[chunkId] + ".js";
};